<template>
  <div v-if="isPreProcessingResultDefined" class="row">
    <div class="card rounded-3 shadow-sm rounded">
      <div class="card-header bg-white border-bottom-0 text-secondary py-1">
        <h4>PreProcessing Result</h4>
      </div>
      <div class="card-body pt-0">

        <div class="row justify-content-center">
        <table class="table col-12 mb-2" :class="{'col-md-8': headersInColumns}">
          <thead>
            <tr>
              <th scope="col">
                <div class="row">
                  <div class="col"></div>
                  <div class="col text-nowrap">Orientation</div>
                  <div class="col"></div>
                </div>
              </th>
              <th scope="col">
                <div class="row">
                  <div class="col"></div>
                  <div class="col text-nowrap">Header</div>
                  <div class="col"></div>
                </div>
              </th>
              <th scope="col">
                <div class="row">
                  <div class="col"></div>
                  <div class="col text-nowrap">Primary Key</div>
                  <div class="col"></div>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="p-0">
                <div class="row">
                  <div class="col"></div>
                  <div class="col">
                    <ScoredDataComponent class="mb-1" :data="PreProcessingResultOrientation" :dataScore="PreProcessingResultOrientationScore"></ScoredDataComponent>
                  </div>
                  <div class="col"></div>
                </div>
              </td>
              <td class="p-0">
                <div class="row">
                  <div class="col"></div>
                  <div class="col">
                    <ScoredDataComponent class="mb-1" :data="PreProcessingResultHasHeader + ' at ' + PreProcessingResultHeaderPosition" :dataScore="PreProcessingResultHasHeaderScore"></ScoredDataComponent>
                  </div>
                  <div class="col"></div>
                </div>
              </td>
              <td class="p-0">
                <div class="row">
                  <div class="col"></div>
                  <div class="col">
                    <ScoredDataComponent class="mb-1" :data="PreProcessingResultHasPrimaryKey + ' at ' + PreProcessingResultPrimaryKeyPosition" :dataScore="PreProcessingResultHasPrimaryKeyScore"></ScoredDataComponent>
                  </div>
                  <div class="col"></div>
                </div>
              </td>
          </tr>
          </tbody>
        </table>
        </div>


        <table v-if="!headersInColumns" class="table mt-3 table-xs">
          <thead>
          <tr>
            <th scope="col">Header</th>
            <th scope="col">Primitive typing</th>

          </tr>
          </thead>
          <tbody>
          <tr v-for="(head, headIndex) in PreProcessingResultHeaderLabel" :key="head.columnIndex">
            <th class="align-middle" scope="row">{{head}}</th>
            <td>
              <div class="row">
                <div class="col"></div>
                  <div class="row">
                    <ScoredDataComponent class="mb-1" v-for="typeTyping in PreProcessingResultPrimitiveTyping[headIndex].typing" :key="typeTyping.columnIndex" :data="typeTyping.typingLabel" :dataScore="typeTyping.typingScore"></ScoredDataComponent>
                  </div>
                <div class="col"></div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div v-if="headersInColumns" class="col-12">
          <h4 class="mt-4 mb-4">Headers primitive typing</h4>

          <div class="table-responsive-sm table-xs pb-0 pr-2 overflow-auto" :style="{'max-height': '700px', 'max-width': '90vw'}">

            <table class="table mb-0 shadow-sm headerAlwaysVisible" >

              <tr class="mb-3 shadow-sm" >
                <th class="" v-for="head in PreProcessingResultHeaderLabel" :key="head.columnIndex">
                  <div v-if="PreProcessingResultHasHeader">{{ head }}</div>
                  <small v-if="!PreProcessingResultHasHeader" class="text-nowrap">{{ head }}</small>
                </th>
              </tr>

              <tr>
                <td class="asHeader border border-300" v-for="(head, headIndex) in PreProcessingResultHeaderLabel" :key="head.columnIndex">
                  <ScoredDataComponent class="mb-1" :SmallScoredDataComponent="true" v-for="typeTyping in PreProcessingResultPrimitiveTyping[headIndex].typing" :key="typeTyping.columnIndex" :data="typeTyping.typingLabel" :dataScore="typeTyping.typingScore"></ScoredDataComponent>
                </td>
              </tr>

              <tr class="spacer">
                <td></td>
              </tr>

              <tr class="shadow-sm" v-for="(line,i) in PreProcessingResultTableDataRevisedMatrix.getRows()" :key="'tr-'+i">
                <td class="border border-300" v-for="(element,index) in line" :key="'th-'+index" :class="{'d-none': !isHeaderLine(i)}">

                  <div>{{ element }}</div>

                </td>
                <td class="border" v-for="(element,index) in line" :key="'td-'+index" :class="{'border-300': !isHeaderLine(i), 'border-600': isHeaderLine(i), 'd-none': isHeaderLine(i)}">

                  <div>{{ element }}</div>

                </td>
              </tr>

            </table>

          </div>
        </div>

      </div>
    </div>
  </div>

</template>
<script>
import ScoredDataComponent from "./ScoredDataComponent";
import TableMatrix from '../../../model/TableMatrix';

export default {
  name: "PreProcessingResult",
  components: {
    ScoredDataComponent
  },
  props: ["PreProcessingResult"],
  data() {
    return {
      headersInColumns: true
    }
  },
  mounted() {
  },
  computed: {
    isPreProcessingResultDefined: function() {
      return (this.PreProcessingResult !== undefined) && (Array.isArray(this.PreProcessingResult)) && (this.PreProcessingResult[0] !== undefined);
    },
    PreProcessingResultOrientation: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.tableOrientation.orientationLabel : undefined;
    },
    PreProcessingResultOrientationScore: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.tableOrientation.orientationScore : undefined;
    },
    PreProcessingResultHasHeader: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.headerInfo.hasHeader : undefined;
    },
    PreProcessingResultHeaderPosition: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.headerInfo.headerPosition : undefined;
    },
    PreProcessingResultHasHeaderScore: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.headerInfo.headerScore : undefined;
    },
    PreProcessingResultHeaderLabel: function() {
      if (this.isPreProcessingResultDefined) {
        // if headerLabel is an empty array, return an array with "<<no header>>" label for each column
        if ((this.PreProcessingResult[0].preprocessed.headerInfo.headerLabel) && (Array.isArray(this.PreProcessingResult[0].preprocessed.headerInfo.headerLabel) && (this.PreProcessingResult[0].preprocessed.headerInfo.headerLabel.length > 0))) {
          return this.PreProcessingResult[0].preprocessed.headerInfo.headerLabel;
        } else {
          const defaultHeader = this.PreProcessingResultPrimitiveTyping.map(() => this.$t('empty-header'));
          return defaultHeader;
        }
      } else {
        return undefined;
      }
    },
    PreProcessingResultHasPrimaryKey: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.primaryKeyInfo.hasPrimaryKey : undefined;
    },
    PreProcessingResultPrimaryKeyPosition: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.primaryKeyInfo.primaryKeyPosition : undefined;
    },
    PreProcessingResultHasPrimaryKeyScore: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.primaryKeyInfo.primaryKeyScore : undefined;
    },
    PreProcessingResultPrimitiveTyping: function() {
      return this.isPreProcessingResultDefined ? this.PreProcessingResult[0].preprocessed.primitiveTyping : undefined;
    },
    PreProcessingResultTableDataRevisedMatrix: function() {
      return this.isPreProcessingResultDefined ? new TableMatrix(this.PreProcessingResult[0].preprocessed.tableDataRevised) : new TableMatrix(undefined);
    }
  },
  methods: {
    isHeaderLine: function(index) {
      let result = false;
      if ((this.PreProcessingResultOrientation === 'HORIZONTAL') && (this.PreProcessingResultHasHeader === true) && (this.PreProcessingResultHeaderPosition === index)) {
      // if ((this.orientation === 'HORIZONTAL') && (this.hasHeader === true) && (10 === index)) {
        result = true;
      } else {
        result = false;
      }
      return result;
    }
  }

};
</script>
<style scoped>

.table-xs td, .table-xs th {
  padding: .2625rem .2625rem calc(.2625rem + 1px);
}

table.headerAlwaysVisible th {
  position: sticky;
  top: 0px;
  background-color: whitesmoke;
}

table.headerAlwaysVisible td.asHeader {
  position: sticky;
  top: 30px;
  background-color: white;
}

</style>